import { ChangeDetectorRef, Component, computed, inject, Input, signal, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GoogleMap, GoogleMapsModule, MapDirectionsService } from '@angular/google-maps';
import { toSignal } from '@angular/core/rxjs-interop';
import { MapsService } from '../maps.service';
import { IconDefinition } from '@fortawesome/free-solid-svg-icons';
import {map} from 'rxjs/operators'

@Component({
  selector: 'iriro-map',
  standalone: true,
  imports: [CommonModule, GoogleMapsModule],
  templateUrl: './map.component.html',
  styleUrl: './map.component.scss',
})
export class MapComponent {
  map = toSignal(inject(MapsService).load());
  mapDirectionsService = inject(MapDirectionsService);

  @ViewChild(GoogleMap) googleMapComponent: GoogleMap | null = null;

  changeDetectorRef = inject(ChangeDetectorRef);

  @Input() set markerConfig(value: MarkerType[]) {
    this._markerConfigSignal.set(value);
    this.changeDetectorRef.detectChanges();
    if (this.googleMapComponent) {
      const bounds = new google.maps.LatLngBounds();
      this._markerConfigSignal().map(({ position }) => {
        bounds.extend(position);
      });
      this.googleMapComponent.fitBounds(bounds);
    }
  }

  @Input() set directionsLatLng(value: DirectionType | null) {
    if(value) {
      this.request.set(value);
    }
  }

  request = signal<DirectionType | null>(null);

  completedDirections = computed(() => {
    const google_map = this.map();
    const request = this.request();
    if (google_map && request) {
      return this.mapDirectionsService
        .route({ ...request, travelMode: google.maps.TravelMode.DRIVING })
        .pipe(map((response) => response.result));
    }

    return undefined;
  });

  googleMap = toSignal(inject(MapsService).load());

  private _markerConfigSignal = signal<MarkerType[]>([]);

  markers = computed(() => {
    return this._markerConfigSignal().map((item) => {
      return {
        position: item.position,
        options: {
          ...item.options,
          icon: {
            path: item.icon?.icon[4] as string,
            fillColor: item.fillColor,
            strokeColor: item.strokeColor,
            fillOpacity: 1,
            anchor: new google.maps.Point(
              item.icon?.icon[0] / 2, // width
              item.icon?.icon[1] // height
            ),
            strokeWeight: 1,
            scale: 0.075,
          },
        },
      };
    });
  });

}

export interface MarkerType {
  position: google.maps.LatLngLiteral | undefined;
  icon?: IconDefinition;
  fillColor?: string;
  strokeColor?: string;
  options?: google.maps.MarkerOptions;
}

export interface DirectionType {
  destination: google.maps.LatLngLiteral | undefined;
  origin: google.maps.LatLngLiteral | undefined;
  waypoints?: google.maps.DirectionsWaypoint[];
}
